/* eslint-disable import/no-named-as-default */
import angular from 'angular';
import InterfaceService from './interface.service';

export default angular.module('autoboard.interface', [InterfaceService])
  // Takes a relative positioned element and applies styles,
  // so that it will remain fixed in the rendered position.
  .directive('followScroll', () => {
    'ngInject';

    return {
      restrict: 'A',
      scope: {},
      link(scope, elem) {
        elem.css('width', `${elem[0].clientWidth}px`);
        elem.css('position', 'fixed');
      },
    };
  })
  .name;
